import React from 'react';
import PropTypes from 'prop-types';
import { useNavigate } from 'react-router-dom';

import Button from 'components/Buttons/Button';
import Modal from 'components/Layout/Modal/Modal';

const SignInOrContinueAsGuestModal = ({
  fnSetShowModal,
  fnSetShowSignInModal,
}) => {
  const fnNavigate = useNavigate();

  const fnStartEventRegistrationAsGuest = () => {
    fnNavigate('/events/register/user-identification');
  };

  return (
    <Modal
      sModalTitle='Thanks for your interest in registering'
      sModalSubtitle='If you have a WakeNetwork account, please sign in for a more seamless registration experience.'
      sFlavor='sign-in'
      fnSetShowModal={fnSetShowModal}
    >
      <div
        className='eventDetailsPage__signInOrContinueAsGuestModalButtons'
        data-cy='sign-in-or-continue-as-guest-modal'
      >
        <Button
          fnHandleClick={() => {
            fnSetShowModal(false);
            fnSetShowSignInModal(true);
          }}
          sCypressId='sign-in-button'
        >
          Sign in
        </Button>
        <span className='t-label'>or</span>
        <Button
          fnHandleClick={fnStartEventRegistrationAsGuest}
          sFlavor='secondary'
          sCypressId='continue-as-guest-button'
        >
          Continue as Guest
        </Button>
      </div>
    </Modal>
  );
};

SignInOrContinueAsGuestModal.propTypes = {
  fnSetShowModal: PropTypes.func.isRequired,
  fnSetShowSignInModal: PropTypes.func.isRequired,
};

export default SignInOrContinueAsGuestModal;
